import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { site_base, site_name } from '../Site';
import GoogleAnalytics from '../GoogleAnalytics';

import { T } from '../traks';

const scrollToId = (elem_id) => window.scrollTo(0, document.getElementById(elem_id).offsetTop+35);

const RenderFAQ = (props) => {
	const table_of_contents = (
		<React.Fragment>
		{props.faq_entries.map((faq_entry) =>
			<div key={faq_entry.id}>
				<Button className="ad_faq_toc_button text-left pl-0" key={faq_entry.id} onClick={() => scrollToId('faq_entry_' + faq_entry.id)}>
					{faq_entry.q}
				</Button>
			</div>
		)}
		</React.Fragment>
	);
	const q_and_as = (
		<React.Fragment>
		{props.faq_entries.map((faq_entry) =>
			<Row key={"faq_entry_" + faq_entry.id} id={"faq_entry_" + faq_entry.id} className="pb-4">
				<Col xs="12" className="ad_faq_entry">
					<div className="ad_faq_q py-3">
					{faq_entry.q}
					</div>
					<div className="ad_faq_a pb-3">
					{faq_entry.a}
					</div>
				</Col>
			</Row>
		)}
		</React.Fragment>
	)
	return (
		<Row className="pt-3 ad_pb-25 px-2 px-md-0">
		<Col xs="12" md="4" className="pl-md-0 pr-md-5">
			<div className="pb-4">
				<b className="ad_little_larger_text"><T>FAQ - contents</T></b>
			</div>
			{table_of_contents}
		</Col>
		<Col xs="12" md="8" className="pl-md-5">
			<div className="pb-4">
				<b className="ad_little_larger_text"><T>Frequently Asked Questions</T></b>
			</div>
			<div className="pb-4">
				<T>
					Here you will find answers to the most important questions about the
					investment game and an introduction on how to get started. If you want
					to refresh your stock knowledge, please visit our Stock ABC. Please
					contact us if you have any further questions.
				</T>
			</div>
		{q_and_as}
		</Col>
		</Row>
	);
}

export const faq_entries = [
	{ id: 1, q: <T context="faq_q_1" deps={[site_name]}></T>, a: <T context="faq_a_1" deps={[site_name]}></T> },
	{ id: 2, q: <T context="faq_q_2" deps={[site_name]}></T>, a: <T context="faq_a_2" deps={[site_name]}></T> },
	{ id: 3, q: <T context="faq_q_3"></T>, a: <T context="faq_a_3" deps={[site_name]}></T> },
	{ id: 4, q: <T context="faq_q_4"></T>, a: <T context="faq_a_4" deps={[site_name]}></T> },
	{ id: 5, q: <T context="faq_q_5"></T>, a: <T context="faq_a_5" deps={[site_name]}></T> },
	{ id: 6, q: <T context="faq_q_6"></T>, a: <T context="faq_a_6"></T> },
	{ id: 7, q: <T context="faq_q_7"></T>, a: <T context="faq_a_7"></T> },
	{ id: 15, q: <T context="faq_q_15"></T>, a: <T context="faq_a_15"></T> },
	{ id: 14, q: <T context="faq_q_14"></T>, a: <T context="faq_a_14"></T> },
	{ id: 8, q: <T context="faq_q_8"></T>, a: <T context="faq_a_8"></T> },
	{ id: 9, q: <T context="faq_q_9"></T>, a: <T context="faq_a_9"></T> },
	{ id: 10, q: <T context="faq_q_10"></T>, a: <T context="faq_a_10"></T> },
	{ id: 11, q: <T context="faq_q_11"></T>, a: <T context="faq_a_11"></T> },
	{ id: 12, q: <T context="faq_q_12"></T>, a: <T context="faq_a_12"></T> },
	{ id: 13, q: <T context="faq_q_13"></T>, a: <T context="faq_a_13"></T> },
	{ id: 16, q: <T context="faq_q_16"></T>, a: <T context="faq_a_16"></T> },
	{ id: 17, q: <T context="faq_q_17" deps={[site_name]}></T>, a: <T context="faq_a_17" deps={[site_name]}></T> },
	{ id: 18, q: <T context="faq_q_18"></T>, a: <T context="faq_a_18" deps={[site_base]}></T> },
	{ id: 19, q: <T context="faq_q_19"></T>, a: <T context="faq_a_19"></T> },
	{ id: 20, q: <T context="faq_q_20"></T>, a: <T context="faq_a_20" deps={[site_base]}></T> },
	{ id: 21, q: <T context="faq_q_21"></T>, a: <T context="faq_a_21"></T> },
	{ id: 22, q: <T context="faq_q_22"></T>, a: <T context="faq_a_22"></T> },
	{ id: 23, q: <T context="faq_q_23"></T>, a: <T context="faq_a_23"></T> },
	{ id: 24, q: <T context="faq_q_24"></T>, a: <T context="faq_a_24"></T> },
];

class FAQ extends Component {
	render() {
		return (
			<Container className="pt-4 ad_faq_and_guide">
				<RenderFAQ faq_entries={faq_entries} />
			</Container>
		);
	}
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/p/FAQ.js